/* eslint no-inline-comments: 0 */

const List = () => import( /* webpackChunkName: "group-oauth2" */ `./list.vue` );
const Add = () => import( /* webpackChunkName: "group-oauth2" */ `./add.vue` );
const AuthEvents = () => import( /* webpackChunkName: "group-oauth2" */ `./auth_events.vue` );
const Edit = () => import( /* webpackChunkName: "group-oauth2" */ `./edit.vue` );

export default {
	path: `oauth2`,
	children: [
		{
			path: ``,
			name: `list-oauth2-clients`,
			component: List,
			meta: {
				title: `OAuth2 Clients`
			}
		},
		{
			// Ahead of the `:uuid` route below, for the same reason `new` is: a
			// static segment must not be readable as a client UUID.
			path: `auth-events`,
			name: `list-oauth2-auth-events`,
			component: AuthEvents,
			meta: {
				title: `OAuth2 Auth Events`
			}
		},
		{
			path: `new`,
			name: `add-oauth2-client`,
			component: Add,
			meta: {
				title: `Add Client`
			}
		},
		{
			path: `:uuid`,
			name: `edit-oauth2-client`,
			component: Edit,
			meta: {
				title: `Edit Client`
			}
		}
	]
};
